import { Endpoint } from '@business/api/endpoint';
import { InvoiceSettingRequest, InvoiceSettingResponse } from '@business/entities/invoiceSetting';
import { CommonService } from '@business/services';

export function fetchSettings(objectId: string, type: string) {
  return Endpoint.get<InvoiceSettingResponse>(`@gc/invoice-settings`, { params: { objectId, type } });
}

export function saveSettings(data: InvoiceSettingRequest) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<InvoiceSettingResponse>(`@gc/invoice-settings`, { formData, hasFiles: true });
}
